import { useQuery } from 'react-query';
import { droplrKeys } from './queryKeys';
import { checkDropAuth } from './droplrAuth';
import { CombinedBoard } from './types';
import { EXPRESS_API } from 'configs/api/expressApi';
import { DEFAULT_BOARD } from 'lib/const/Droplr';

export type GetBoardParams = {
  userId: number;
  customerId: number;
  boardId: string;
};

const getBoard = async (params: GetBoardParams) => {
  const { boardId, userId, customerId } = params;

  if (!boardId) return DEFAULT_BOARD;

  await checkDropAuth();
  // fetch board details from covideo
  const covideoResponse = (
    await EXPRESS_API.get('/board', {
      params: {
        userId,
        customerId,
        droplrBoardId: boardId,
      },
    })
  ).data;
  return covideoResponse?.board as CombinedBoard;
};

export const useGetBoard = (params: GetBoardParams) => {
  return useQuery(droplrKeys.board_details(params), () => getBoard(params));
};
